module.exports = __webpack_public_path__ + "static/media/info-icon-full.afc4beb5.svg";